import React, { useContext,
  // useState 
} from 'react';
import { AuthContext } from '../../context/auth';
import Header from '../../components/Header';
// import moment from 'moment';
import logo1 from '../../imagenes/opensiap_sigat.jpeg'
import logo2 from '../../imagenes/logo33.png'
import Footer from '../../components/Footer';
function HaciendaMunicipal(props) {
  const { user, logout } = useContext(AuthContext);
  const seleccionar = (pathname) => (event) => {
    event.preventDefault();
    props.history.push(pathname);
  }

  // let op = require('../../../public/../src/modulos/datos');
  // const [fechaSistema, setFechaSistema] = useState(JSON.parse(localStorage.getItem('fechasistema')));


  return user && (
      <div>
      <Header />
          <div className='container'>
          <div className='container row col-md-12 py-3' style={{ padding: 0, margin: 0 }}>
            <img src={logo2} className="imagens" />
            <div className='col-md-3 col-6 col-sm-6'>
              <div className='col-md-12 col-6 mt-3'>
                 <button className='links col-md-12 d-flex btn-light justify-content-around align-items-center' style={{ backgroundColor: '#acd6fb', borderRadius: "40px 0px 0px 40px", width: "100%", minWidth: "160px" }} onClick={seleccionar("/actividadEconomica")}>
                  <i className="fas fa-calculator fs-1 bg-light second-text secondary-bg p-1 mr-auto" style={{ border: "5px ridge #ffffff", borderRadius: "40px 40px 40px 40px" }} />
                  <div>
                    <p className="fw-bold">Actividades Economicas</p>
                  </div>
                </button> 
              </div>
              <div className='col-md-12 col-6 mt-5'>
                  <button className='links col-md-12 d-flex btn-light justify-content-around align-items-center' style={{ backgroundColor: '#88befc', borderRadius: "40px 0px 0px 40px", width: "100%", minWidth: "160px" }} onClick={seleccionar("/inmueblesUrbanos")}>
                  <i className="fas fa-home fs-1 bg-light second-text secondary-bg p-1 mr-auto" style={{ border: "5px ridge #ffffff", borderRadius: "40px 40px 40px 40px" }} />
                  <div>
                    <p className="fw-bold">Inmuebles Urbanos</p>
                  </div>
                </button> 
              </div>
              <div className='col-md-12 col-6 mt-5'>
                 <button className='links col-md-12 d-flex btn-light justify-content-around align-items-center' style={{ backgroundColor: '#233671', borderRadius: "40px 0px 0px 40px", width: "100%", minWidth: "160px" }} onClick={seleccionar("/impuestoVehiculos")}>
                  <i className="fas fa-car-alt fs-1 bg-light second-text secondary-bg p-1 mr-auto" style={{ border: "5px ridge #ffffff", borderRadius: "40px 40px 40px 40px" }} />
                  <div>
                    <p className="fw-bold text-warning">Impuestos de Vehiculos</p>
                  </div>
                </button> 
              </div>
              <div className='col-md-12 col-6 mt-5'>
                  <button className='links col-md-12 d-flex btn-light justify-content-around align-items-center' style={{ backgroundColor: '#88befc', borderRadius: "40px 0px 0px 40px", width: "100%", minWidth: "160px" }} onClick={seleccionar("/impuestoPP")}>
                  <i className="fas fa-info-circle fs-1 bg-light second-text secondary-bg p-1 mr-auto" style={{ border: "5px ridge #ffffff", borderRadius: "40px 40px 40px 40px" }} />
                  <div>
                    <p className="fw-bold">Propaganda y Publicidad</p>
                  </div>
                </button> 
              </div>
              <div className='col-md-12 col-6 mt-5'>
               <button className='links col-md-12 d-flex btn-light justify-content-around align-items-center' style={{ backgroundColor: '#add6fa', borderRadius: "40px 0px 0px 40px", width: "100%", minWidth: "160px" }} onClick={seleccionar("/rentasInmobiliria")}>
                  <i className="fas fa-warehouse fs-1 bg-light second-text secondary-bg p-1 mr-auto" style={{ border: "5px ridge #ffffff", borderRadius: "40px 40px 40px 40px" }} />
                  <div className=''>
                    <p className="fw-bold">Renta Inmobiliarias</p>
                  </div>
                </button> 
              </div>
            </div>
            <div className='col-md-6 prue'>
              <figure className="figure rounded-circle" for="check" id="central" style={{ borderRight: "14px solid #ffffff", borderTop: " 14px solid #ffff", borderBottom: "14px solid #ffff", padding: "20px", borderLeft: "14px solid #ffffff" }}>
                <img src={logo1} className="figure-img img-fluid rounded-circle" style={{
                  borderLeft: "10px ridge #ffffff", borderRight: "10px groove #ffff",
                  borderBottom: "10px groove #ffff", borderTop: "10px ridge #ffff"/* , WebkitBoxShadow: "1px 5px 14px -1px rgba(0,0,0,0.69)", boxShadow: "1px 5px 14px -1px rgba(0,0,0,0.69)" */
                }} />
              </figure>
            </div>
            <div className='col-md-3 col-6 col-sm-6'>
              <div className='col-md-12 col-6 mt-3'>
                  <button className='links2 col-md-12 d-flex btn-light justify-content-around align-items-center' style={{ backgroundColor: '#acd6fb', borderRadius: "0px 40px 40px 0px", width: "100%", minWidth: "160px" }} onClick={seleccionar("/moduloFacturacion")}>
                  <div className=''>
                    <p className="fw-bold">Facturacion</p>
                  </div>
                  <i className="fas fa-cash-register fs-1 bg-light second-text secondary-bg p-1 ml-auto" style={{ border: "5px ridge #ffffff", borderRadius: "40px 40px 40px 40px" }} />
                </button> 
              </div>
              <div className='col-md-12 col-6 mt-5'>
                  <button className='links2 col-md-12 d-flex btn-light justify-content-around align-items-center' style={{ backgroundColor: '#88befc', borderRadius: "0px 40px 40px 0px", width: "100%", minWidth: "160px" }} onClick={seleccionar("/JuegosApuestas")}>
                  <div className=''>
                    <p className="fw-bold">Juegos y Apuestas</p>
                  </div>
                  <i className="fas fa-diagnoses fs-1 bg-light second-text secondary-bg p-1 ml-auto" style={{ border: "5px ridge #ffffff", borderRadius: "40px 40px 40px 40px" }} />
                </button> 
              </div>
              <div className='col-md-12 col-6 mt-5'>
                   <button className='links2 col-md-12 d-flex btn-light justify-content-around align-items-center' style={{ backgroundColor: '#233671', borderRadius: "0px 40px 40px 0px", width: "100%", minWidth: "160px" }} onClick={seleccionar("/impuestoLicores")}>
                  <div className=''>
                    <p className="fw-bold text-warning">Renta de Licores</p>
                  </div>
                  <i className="fas fa-cocktail fs-1 bg-light second-text secondary-bg p-1 ml-auto" style={{ border: "5px ridge #ffffff", borderRadius: "40px 40px 40px 40px" }} />
                </button> 
              </div>
              <div className='col-md-12 col-6 mt-5'>
               <button className='links2 col-md-12 d-flex btn-light justify-content-around align-items-center' style={{ backgroundColor: '#88befc', borderRadius: "0px 40px 40px 0px", width: "100%", minWidth: "160px" }} onClick={seleccionar("/gestioncomercial")} >
                  <div className=''>
                    <p className="fw-bold">Gestión Comercial</p>
                  </div>
                  <i className="fas fa-chalkboard-teacher fs-1 bg-light second-text secondary-bg p-1 ml-auto" style={{ border: "5px ridge #ffffff", borderRadius: "40px 40px 40px 40px" }} />
                </button> 
              </div>
              <div className='col-md-12 col-6 mt-5'>
                <button className='links2 col-md-12 d-flex btn-light justify-content-around align-items-center' onClick={seleccionar("/caja")} style={{ backgroundColor: '#add6fa', borderRadius: "0px 40px 40px 0px", width: "100%", minWidth: "160px" }} >
                  <div className=''>
                    <p className="fw-bold">Caja</p>
                  </div>
                  <i className="fas fa-kaaba fs-1 bg-light second-text secondary-bg p-1 ml-auto" style={{ border: "5px ridge #ffffff", borderRadius: "40px 40px 40px 40px" }} />
                </button>
              </div>
            </div>
          </div>
        </div>
        <Footer/>
      </div>
    )
}


export default HaciendaMunicipal;
